import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import moment from 'moment'
import { WTPEquipmentTypeDDLData } from '../../../../../Components/CommonDDL/WTPEquipmentTypeDDLData';
import { WTPEquipmentNameDDL } from '../../../../../Components/CommonDDL/WTPEquipmentNameDDL';
import { WTPMachineryChecklistPostDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/PreventiveData/MachineryChecklistSlice';
import { useAuthState } from '../../../../../Helper/Context';
import { WTPActionDDL } from '../../../../../Components/CommonDDL/WTPActionDDL';

export default function WTPMachineryChecklistDataPopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [EquipmentName, setEquipmentName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_EquipmentMasterID : '0',
        Label: Flag === 'Update' ? rowData.equipmentDetails : '0',
    })

    const [WtpEquipmentType, setWtpEquipmentType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_EquipmentTypeID : '0',
        Label: Flag === 'Update' ? rowData.equipmentType : '0',
    })

    const [Status, setStatus] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_MachineryActionsID : '0',
        Label: Flag === 'Update' ? rowData.actionName : '0',
    })

    const [MachineryChecklistTextField, setMachineryChecklistTextField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        remarks: Flag === 'Update' ? rowData.remarks : '',
        // machineryDetails: Flag === 'Update' ? rowData.machineryDetails : '',
    })

    const handleMachineryChecklistTextField = (e) => {
        setMachineryChecklistTextField({ ...MachineryChecklistTextField, [e.target.name]: e.target.value })
    }

    // console.log(rowData.equipmentType)

    const handlePost = () => {
        const data = {
            T_WTP_MachineryChecklistID: Flag === 'Update' ? rowData.t_wtP_MachineryChecklistID : '0',
            M_WTP_MachineryActionsID: Status.ID,
            Remarks: MachineryChecklistTextField.remarks,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(WTPMachineryChecklistPostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Machinery Checklist</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="readingDate"
                                            name='readingDate'
                                            value={MachineryChecklistTextField.readingDate}
                                            onChange={(e) => handleMachineryChecklistTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-lg-3 col-lg-6 col-md-6">
                                    <WTPEquipmentTypeDDLData
                                        WtpEquipmentType={WtpEquipmentType}
                                        setWtpEquipmentType={setWtpEquipmentType}
                                        rowData={rowData}
                                        Flag={Flag}
                                        IsDisabled={true}
                                    // Flag='ward'
                                    />

                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <WTPEquipmentNameDDL
                                        EquipmentName={EquipmentName}
                                        setEquipmentName={setEquipmentName}
                                        WtpEquipmentType={WtpEquipmentType}
                                        rowData={rowData}
                                        Flag={Flag}
                                        IsDisabled={true}
                                    // Flag='ward'
                                    />

                                </div>
                                <div className="col-12 col-lg-6">
                                    <WTPActionDDL
                                        Status={Status}
                                        setStatus={setStatus}
                                        rowData={rowData}
                                        Flag={Flag}
                                    // Flag='ward'
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Remark</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="remarks"
                                            name='remarks'
                                            value={MachineryChecklistTextField.remarks}
                                            onChange={(e) => handleMachineryChecklistTextField(e)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    // disabled={
                                    //     MachineryChecklistTextField.readingDate == '' || MachineryChecklistTextField.machEquipmentType == '' ||
                                    //     MachineryChecklistTextField.machineryDetails == '' || Status.ID == 0
                                    // }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}